import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { useMemo } from "react";

type SurveyHeaderProps = {
  innerHeight: number;
};

export default function SurveyHeader({ innerHeight }: SurveyHeaderProps) {
  const bgImgWidth = useMemo(() => {
    if (innerHeight <= 670) return 400;
    return 650;
  }, [innerHeight]);

  const mojoImgWidth = useMemo(() => {
    if (innerHeight <= 670) return 100;
    return 140;
  }, [innerHeight]);

  const bgImgMarginTop = useMemo(() => {
    if (innerHeight >= 1000) return 150;
    return 0;
  }, [innerHeight]);

  const mojoImgMarginTop = useMemo(() => {
    if (innerHeight <= 670) return 20;
    if (innerHeight >= 1000) return 210;
    return 30;
  }, [innerHeight]);

  return (
    <div sx={{ overflowX: "hidden" }}>
      <img
        src={"/static/images/space-bg-nps.png"}
        sx={{
          width: bgImgWidth,
          marginLeft: RAW_cssValue("50%"),
          transform: "translateX(-50%)",
          marginTop: RAW_cssValue(bgImgMarginTop),
        }}
      />
      <img
        src={"/static/images/mojo-nps.png"}
        sx={{
          position: "absolute",
          width: mojoImgWidth,
          top: mojoImgMarginTop,
          left: 0,
          right: 0,
          margin: RAW_cssValue("0 auto"),
        }}
      />
    </div>
  );
}
